import RichTextarea from "./main.vue";

/* istanbul ignore next */
RichTextarea.install = function(Vue) {
  Vue.component(RichTextarea.name, RichTextarea);
};

export default RichTextarea;
